import axios from 'axios';
import Vue from 'vue';
import { Toast } from '@zyf2e/capui-mobile';
import { ZYToast } from '@zyf2e/adapt';
import util from '../util';

Vue.use(Toast);

let apigw = axios.create({
  baseURL: util.getGwApi(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  withCredentials: true
});
// if (Sailer.isWechat) {
if (!util.tyApp) {
  apigw.defaults.withCredentials = true;
}
apigw.interceptors.request.use((config) => {
  if (config.loading) {
    ZYToast.open(config.loadingText || '加载中');
  }

  //config.headers.token = util.getCookie('user_token');
  return config;
});

apigw.interceptors.response.use(
  (res) => {
    ZYToast.close();
    var response = res.data;
    if (response.ok) {
      return response.result;
    } else if (response.error && ['INVALID_TOKEN', '4001', 'LOGIN_REQUIRED'].includes(response.error.code)) {
      // 后端token失效只能返回'4001'
      util.reAuth();
    } else {
      Toast(response.error.message);
      return Promise.reject(response.error);
    }
  },
  (error) => {
    ZYToast.close();

    if (error.response && error.response.status === 401) {
      if (!util.tyApp) {
        // 微信重新授权
        util.reAuth();
      }
    } else {
      if (error.response && error.response.data && error.response.data.error && error.response.data.error.message) {
        Toast(error.response.data.error.message);
      }

      // if (!error.response && error.message === 'Network Error') {
      //   Toast('网络异常，请稍后重试');
      // }

      if (!error.response && error.message.indexOf('timeout') > -1) {
        Toast('连接超时');
      }
    }

    return Promise.reject(error);
  }
);

let gwGet = apigw.get;
apigw.get = function (url, data = {}, config = {}) {
  config.params = data;
  return gwGet(url, config);
};

export { apigw, axios };
